import axios from "axios";
import AsyncStorage from '@react-native-async-storage/async-storage';
export function filterScannedList(items) {
  if (items?.length > 0) {
    const result = Object.values(
      items.reduce((acc, item) => {
        const { product_id, qty_remaining, scanned_qty, total_qty, ...rest } = item;
        if (acc[product_id]) {
          acc[product_id].scanned_qty += scanned_qty;
          acc[product_id].qty_remaining += qty_remaining;
        } else {
          acc[product_id] = { product_id, scanned_qty, qty_remaining, total_qty, ...rest };
        }
        return acc;
      }, {})
    );
    return result;
  }
  return []
}

export function SortList(items) {
  const list = items
  list?.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
}

export function getItemSkuByOrderItemId(orderItemId, unscannedItems) {
  if (Array.isArray(unscannedItems)) {
    const item = unscannedItems.find(item => item.order_item_id === orderItemId);


    if (item) {
      return item.sku;
    }
  }
};

export const getUpdatedSelectedList = (e, isShiftPressed, perviousSelectedOrders) => {
  let selected = e.selected;
  if (selected === true || selected === false) {
    const indicesToRemove = Object.keys(e.unselected || {});

    let selectedObjects = [...e.originalData];

    if (indicesToRemove.length > 0) {
      indicesToRemove.forEach(strIndex => {
        const index = parseInt(strIndex, 10) - 1;
        if (index >= 0 && index < selectedObjects.length) {
          selectedObjects.splice(index, 1);
        }
      });
      selected = selectedObjects;
    } else {
      if (e?.data?.length === undefined) {
        selected = [...e.originalData];
      } else {
        selected = e.data;
      }
    }
  }
  if (isShiftPressed && perviousSelectedOrders) {
    selected = handleShiftKeySelection(e, perviousSelectedOrders, selected);
  }
  return selected;
};

export const handleShiftKeySelection = (e, perviousSelectedOrders, selected) => {
  const lastSelectedOrders = {...perviousSelectedOrders};
  const originalData = [...e.originalData];
  const data = {...e.data};
  const unSelectedOrders = Object.keys(e.unselected || {});

  if (unSelectedOrders.length > 0) {
    return selected;
  }

  try {
    const lowerLimitId = Object.values(lastSelectedOrders)
      .filter(order => order.id < data.id)
      .reduce((prev, curr) => (curr.id > prev.id ? curr : prev), {
        id: -Infinity
      });

    const extractedRecords = originalData.filter(
      item => item.id >= lowerLimitId.id && item.id <= data.id
    );

    const mergedObject = {};
    Object.values(lastSelectedOrders).forEach(order => {
      mergedObject[order.id] = order;
    });
    extractedRecords.forEach(record => {
      mergedObject[record.id] = record;
    });

    const updatedList = getTransformedList(mergedObject);
    return updatedList;
  } catch (error) {
    console.log('error', error);
    return selected;
  }
};

export const getSelectedOrderIds = data => {
  const orderIds = Object.values(data || {}).flatMap(pageSelections =>
    Object.values(pageSelections).map(item => ({id: item.currentItem?.id}))
  );
  return orderIds;
}

export const getSelectedOrders = data => {
  const selectedOrdersArray = Object.values(data || {}).reduce(
    (allSelections, pageSelections) =>
      allSelections.concat(Object.values(pageSelections)),
    []
  );
  return selectedOrdersArray;
}

export const getTransformedList = (data) => {
  const transformedData = {};
  Object.values(data || {})?.forEach(item => {
    transformedData[item.id] = item;
  });
  return transformedData;
}


export async function getLiveStatsData() {
  try {
      const access_token = await AsyncStorage.getItem('access_token');
      const tenent = await AsyncStorage.getItem('tenent');
      const response = await axios.get(
        'https://api-gl.groove-packer.com/dashboard/calculate',
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${access_token}`,
            domain: 'groovepackerapi.com',
            tenant: tenent
          }
        }
      );

      // console.log('Dashboard data:', response.data);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    }
}

export const handleOrderReScan = async ({
  searchOrder,
  orderNumberInput,
  closePopupRescan,
  setState,
  maxAttempts = 3,
}) => {
  let attempts = 0;

  const callBack = async () => {
    const time = attempts === 0 ? 3000 : 1500;

    closePopupRescan();
    setState({ newLoading: true, loaderTitle: 'Loading...' });

    setTimeout(() => {
      handleCallBack();
    }, time);
  };

  const handleCallBack = async () => {
    attempts++;
    const statusChange = await AsyncStorage.getItem('statusChange');

    if (statusChange === 'completed') {
      searchOrder(orderNumberInput);
      setState({ orderNumberInput: '', newLoading: false });
      await AsyncStorage.removeItem('statusChange');
      attempts = 0;
    } else if (attempts <= maxAttempts) {
      await callBack();
    }
  };

  await callBack();
};

export const getUserName = (userId, usersData) => {
  if (!usersData || !Array.isArray(usersData)) {
    return 'Unassigned';
  }

  if (!userId) {
    return 'Unassigned';
  }

  const foundUser = usersData.find(user =>
    user.id === userId ||
    user.user_id === userId ||
    user.username === userId ||
    String(user.id) === String(userId) ||
    String(user.user_id) === String(userId)
  );

  return foundUser?.username || foundUser?.name || 'Unassigned';
};

export const getUserIdLabelArray = usersData => {
  if (!usersData || !Array.isArray(usersData)) {
    return [{id: 'unassigned', label: 'Unassigned'}];
  }

  return [
    {id: 'unassigned', label: 'Unassigned'},
    ...(usersData.map(user => ({
      id: user.username || user.name || user.id,
      label: user.username || user.name || user.id
    })) || [])
  ];
};
export const getTagIdLabelArray = tags => {
  if (tags && tags.data) {
    return tags.data
      .filter(tag => tag.name && tag.name.length > 0)
      .map(tag => ({
        id: tag.name,
        label: tag.name
      }));
  }
  return [];
};

export const processUserAndTagFilter = (filterValue, includedTags, filterIncludedTags = true, includedSkus = [], filterIncludedSkus = true) => {
  let selectedUserFilter = filterValue.find(item => item.name === 'User');
  let selectedTagFilter = filterValue.find(item => item.name === 'Tags');
  let selectedSkuFilter = filterValue.find(item => item.name === 'Skus');

  const selectedUser = Array.isArray(selectedUserFilter?.value)
    ? selectedUserFilter.value.filter(Boolean)
    : (selectedUserFilter?.value ? [selectedUserFilter.value] : []);
  let selectedTag = [];
  if (selectedTagFilter?.value) {
    if (Array.isArray(selectedTagFilter.value)) {
      selectedTag = selectedTagFilter.value.length > 0 ? selectedTagFilter.value : [];
    } else if (typeof selectedTagFilter.value === 'string' && selectedTagFilter.value.length > 0) {
      selectedTag = [selectedTagFilter.value];
    }
  }

  let selectedSku = [];
  if (selectedSkuFilter?.value) {
    if (Array.isArray(selectedSkuFilter.value)) {
      selectedSku = selectedSkuFilter.value.length > 0 ? selectedSkuFilter.value : [];
    } else if (typeof selectedSkuFilter.value === 'string' && selectedSkuFilter.value.length > 0) {
      selectedSku = [selectedSkuFilter.value];
    }
  }

  let updatedFilterValue = [...filterValue];
  if (selectedUser?.length > 0) {
    updatedFilterValue = updatedFilterValue.filter(
      item => item.name !== 'User'
    );
  }

  if (selectedTagFilter) {
    const tagsFilterIndex = updatedFilterValue.findIndex(item => item.name === 'Tags');
    const tagsOperator = filterIncludedTags ? 'eq' : 'neq';
    if (tagsFilterIndex >= 0) {
      updatedFilterValue[tagsFilterIndex] = {
        ...updatedFilterValue[tagsFilterIndex],
        operator: tagsOperator
      };
    } else {
      updatedFilterValue.push({
        ...selectedTagFilter,
        operator: tagsOperator
      });
    }
  }

  if (selectedSkuFilter) {
    const skusFilterIndex = updatedFilterValue.findIndex(item => item.name === 'Skus');
    const skusOperator = filterIncludedSkus ? 'eq' : 'neq';
    if (skusFilterIndex >= 0) {
      updatedFilterValue[skusFilterIndex] = {
        ...updatedFilterValue[skusFilterIndex],
        operator: skusOperator
      };
    } else {
      updatedFilterValue.push({
        ...selectedSkuFilter,
        operator: skusOperator
      });
    }
  }

  const isTagIncluded = selectedTagFilter?.value && (
    Array.isArray(selectedTagFilter.value)
      ? selectedTagFilter.value.some(tagValue =>
          includedTags?.some(item => item.name === tagValue)
        )
      : includedTags?.some(item => item.name === selectedTagFilter.value)
  );

  const isSkuIncluded = selectedSkuFilter?.value && (
    Array.isArray(selectedSkuFilter.value)
      ? selectedSkuFilter.value.some(skuValue =>
          includedSkus?.some(item => item.name === skuValue)
        )
      : includedSkus?.some(item => item.name === selectedSkuFilter.value)
  );

  return {selectedUser, selectedTag, selectedSku, isTagIncluded, isSkuIncluded, updatedFilterValue};
};


export const priorityListDisplayToggle = (id, state, setState) => {
  if (id === 4) {
      reloadGird(state)
      return;
  }
  const isLowPriority = id < 2;

  setState({
      ...state,
      selectedMenuId: id,
      displayPriorityList: !isLowPriority
  });
};

export const reloadGird = state => {
  state.gridRef?.current.reload?.();
};
